import React, { useState, useEffect } from 'react';
import Modal from '../../../../../../common/Modal';

const EditSectionModal = ({ isOpen, onClose, onSubmit, section }) => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // تحميل بيانات القسم عند فتح النموذج
  useEffect(() => {
    if (section && isOpen) {
      setTitle(section.title || '');
      setDescription(section.description || '');
    }
  }, [section, isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // التحقق من البيانات
    if (!title.trim()) {
      setError('يرجى إدخال عنوان القسم');
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      // إرسال البيانات
      await onSubmit({
        title,
        description
      });
      
      // إغلاق النموذج
      onClose();
    } catch (error) {
      console.error('Error updating section:', error);
      setError('حدث خطأ أثناء تعديل القسم');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    // إعادة تعيين النموذج عند الإغلاق
    setError('');
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="تعديل القسم"
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        {error && (
          <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-md">
            {error}
          </div>
        )}
        
        <div>
          <label htmlFor="title" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            عنوان القسم <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            id="title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-700 dark:text-white"
            placeholder="أدخل عنوان القسم"
            required
          />
        </div>
        
        <div>
          <label htmlFor="description" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            وصف القسم
          </label>
          <textarea
            id="description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows="3"
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-700 dark:text-white"
            placeholder="أدخل وصفًا للقسم (اختياري)"
          />
        </div>
        
        <div className="flex justify-end space-x-3 space-x-reverse">
          <button
            type="button"
            onClick={handleClose}
            className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            إلغاء
          </button>
          <button
            type="submit"
            disabled={loading}
            className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'جاري الحفظ...' : 'حفظ التغييرات'}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default EditSectionModal;
